import { memo, useMemo } from 'react'
import { HistoricoPanelProps } from 'view/atendimentos/detail/historico/model/model-historico'

import HistoricoAtendimentoOdontoDw from './dw/HistoricoAtendimentoOdontoDw'
import HistoricoAtendimentoOdontoPec from './pec/HistoricoAtendimentoOdontoPec'

function HistoricoAtendimentoOdontoPanel(props: HistoricoPanelProps) {
  const { isAtendRecente, idAtend, idadeOrigemAtendimento, cpfOuCnsCidadao, uuidRegistro, dataNascimento } = props

  const atendimentoPecProcessado: boolean = !isAtendRecente && idAtend

  const selectContent = useMemo(() => {
    return isAtendRecente || atendimentoPecProcessado ? (
      <HistoricoAtendimentoOdontoPec
        idAtend={idAtend}
        idadeOrigemAtendimento={idadeOrigemAtendimento}
        dataNascimento={dataNascimento}
      />
    ) : (
      <HistoricoAtendimentoOdontoDw
        uuidRegistro={uuidRegistro}
        cpfOuCnsCidadao={cpfOuCnsCidadao}
        idadeOrigemAtendimento={idadeOrigemAtendimento}
      />
    )
  }, [
    isAtendRecente,
    atendimentoPecProcessado,
    idAtend,
    idadeOrigemAtendimento,
    dataNascimento,
    uuidRegistro,
    cpfOuCnsCidadao,
  ])

  return selectContent
}

export default memo(HistoricoAtendimentoOdontoPanel)
